// Author YuJiaBei
// Date 2021-01-05 08:33:12

import * as model from "@/model/em/repair/RepairConstructionUnitModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.RepairConstructionUnit(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_EM_REPAIR_URL,
    })
    .buildStore()
